import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useAppState } from "./useReduxState"
import { getFeedbackTags } from "../Actions/API/Job/JobActions"
import { FetchState } from "../Models/Client/FetchState"
import { APIFeedbackTag } from "../Models/API/JobFeedbackModel"

export const useFeedbackTags = (
    appID: string
): FetchState<APIFeedbackTag[]> => {
    const dispatch = useDispatch()
    const feedbackTags = useAppState(state => {
        if (!appID) {
            return undefined
        }
        return state.api.jobs.feedbackTags[appID]
    })

    useEffect(() => {
        if (!feedbackTags) {
            dispatch(getFeedbackTags(appID))
        }
    }, [dispatch, appID, feedbackTags])

    return feedbackTags
}
